import { Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { loaderService } from "../services/loaderService";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CircularProgress, { circularProgressClasses } from "@mui/material/CircularProgress";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { useHistory } from "react-router-dom";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
	},
}));

function FacebookCircularProgress(props) {
	return (
		<Box sx={{ position: "relative" }}>
			<CircularProgress
				variant='determinate'
				sx={{
					color: (theme) => theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
				}}
				size={40}
				thickness={4}
				{...props}
				value={100}
			/>
			<CircularProgress
				variant='indeterminate'
				disableShrink
				sx={{
					color: (theme) => (theme.palette.mode === "light" ? "#1a90ff" : "#308fe8"),
					animationDuration: "550ms",
					position: "absolute",
					left: 0,
					[`& .${circularProgressClasses.circle}`]: {
						strokeLinecap: "round",
					},
				}}
				size={40}
				thickness={4}
				{...props}
			/>
		</Box>
	);
}

const LoaderMaestros = ({ id = "defaultLoader" }) => {
	let history = useHistory();
	const [loader, setLoader] = useState(null);

	useEffect(() => {
		const subscription = loaderService.onLoader(id).subscribe((load) => {
			if (!load.label) {
				setLoader(null);
			} else {
				setLoader(load);
			}
		});

		const historyUnlisten = history.listen(() => {
			loaderService.clear(id);
		});

		return () => {
			subscription.unsubscribe();
			historyUnlisten();
		};
	}, []);

	const removeLoader = () => {
		setLoader(null);
	};

	if (!loader) return null;

	return (
		<Modal
			id={loader.id}
			show={true}
			onHide={() => removeLoader()}
			className='modalMaestros'
			centered
			style={{ zIndex: 999999999999999 }}
			backdrop='static'
		>
			<Modal.Body className='p-0'>
				{/* <div className='d-flex flex-column justify-content-center align-items-center p-4' style={{ textAlign: "center" }}> */}
				<div>
					<FacebookCircularProgress />
					<p className='text-black-50 mb-1 mt-3'>{loader.label}</p>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export { LoaderMaestros };
